var render, staticRenderFns
import script from "./NavigationPanelWrapper.vue?vue&type=script&lang=ts&"
export * from "./NavigationPanelWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationPanelWrapper.vue?vue&type=style&index=0&id=d86d8958&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86d8958",
  null
  
)

export default component.exports